// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CourseLecturerTile_wrapper__8YdmO","name":"CourseLecturerTile_name__UC7Mr"};